import { useTranslation } from 'next-i18next'
import { mustBeMaxLength } from '@captaincause/lib/form/mustBeMaxLength'
import { useMixpanel } from '@captaincause/lib/mixpanel'
import { useNextLocale } from '@captaincause/lib/useNextLocale'
import { Form } from '@captaincause/ui/Form'
import { TextInputField } from '@captaincause/ui/TextInput/Field'
import type { FormApi } from 'final-form'

interface Values {
  search: string
}

type SearchBarProps = {
  showSpinner: boolean
  setSearchInput: (props: string) => void
  searchInput: string
}

export const SearchBar = ({
  showSpinner,
  setSearchInput,
  searchInput,
}: SearchBarProps) => {
  const { track } = useMixpanel()
  const { t } = useTranslation('filters.component')

  const locale = useNextLocale()

  const initialSearchValues: Values = {
    search: searchInput,
  }

  const clearSearchInput = (form: FormApi<Values, Partial<Values>>) => {
    track(`Clear projects search filter`)
    setSearchInput('')
    form.reset()
  }

  const handleSearchSubmit = async (values: Values) => {
    track('Submit projects search filter', { search: values.search })
    setSearchInput(values.search)

    return undefined
  }

  return (
    <Form<Values>
      initialValues={initialSearchValues}
      onSubmit={handleSearchSubmit}
      locale={locale}
      withToastOnFailure
      className="flex-1 md:max-w-[170px] md:flex-none lg:max-w-none"
    >
      {({ form }) => (
        <>
          {/* TODO: add an option to submit on change */}
          <TextInputField
            name="search"
            type="search"
            placeholder={t('search')}
            showSpinner={showSpinner}
            clear={() => clearSearchInput(form)}
            className="h-10 border-inside py-4 pl-9 pr-7 text-sm duration-300 ease-out focus-visible:outline-none md:py-2 [&>svg]:max-w-[12px]"
            validators={{
              mustBeMaxLength: {
                fn: mustBeMaxLength,
                constraints: {
                  max: 30,
                },
              },
            }}
            locale={locale}
          />
        </>
      )}
    </Form>
  )
}
